import { Radio, RadioChangeEvent } from 'antd';
import React, { memo } from 'react';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useTypedSelector } from '../../../store';
import { compensationOnUpdated } from '../../../store/lawsuitOpts';
import { CardRadioButton, GRID_LG } from '../../../styles';
import { COMPENSATION_BASIS_ACT } from '../../../utils/helpers/lawBasis';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import StepCard from '../StepCard/StepCard';


const CompensationSelect = () => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  const  { compensationOn } =  useTypedSelector(state =>
    state.lawsuitOpts, shallowEqual);

  const dispatch = useAppDispatch();

  const onPress = (event:RadioChangeEvent) => {
    dispatch(compensationOnUpdated(event.target.value === 2));
  };
  const radioStyle = {
    display: 'block',
    height: '32px',
    lineHeight: '32px',
  };

  const desc =  `${t('compensationSelect.desc1')} art. 10 ${COMPENSATION_BASIS_ACT} ${t('compensationSelect.desc2')}`;

  if (width < GRID_LG) {
    return (
      <StepCard title={t('compensationSelect.title')} desc={desc}>
        <Radio.Group
          onChange={onPress}
          value={compensationOn ? 2 : 1}
          style={{ width: '100%' }}
        >
          <CardRadioButton value={1}>
            {t('No')}
          </CardRadioButton>
          <CardRadioButton value={2}>
            {t('Yes')}
          </CardRadioButton>
        </Radio.Group>
      </StepCard>
    );
  }
  return (
    <StepCard title={t('compensationSelect.title')} desc={desc}>
      <Radio.Group
        onChange={onPress}
        value={compensationOn ? 2 : 1}
      >
        <Radio style={radioStyle} value={1}>
          {t('No')}
        </Radio>
        <Radio style={radioStyle} value={2}>
          {t('Yes')}
        </Radio>
      </Radio.Group>
    </StepCard>
  );
};


export default memo(CompensationSelect);
